import { render, staticRenderFns } from "./dict.vue?vue&type=template&id=2ad8b4c3&scoped=true&"
import script from "./dict.vue?vue&type=script&lang=js&"
export * from "./dict.vue?vue&type=script&lang=js&"
import style0 from "./dict.vue?vue&type=style&index=0&id=2ad8b4c3&prod&lang=scss&scoped=true&"
import style1 from "./dict.vue?vue&type=style&index=1&id=2ad8b4c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad8b4c3",
  null
  
)

export default component.exports